import { toggleAccordion } from "../accordion";
import { formValidation } from "../formValidation";
import { Modal } from "../modal";

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

document.addEventListener("DOMContentLoaded", (e) => {
    document.querySelectorAll('.accordion-trigger').forEach(accordionTrigger => {
        accordionTrigger.addEventListener('click', (e) => {
            toggleAccordion(accordionTrigger);
        });
    });

    let events = ["keyup", "change"]
    events.forEach(event => formValidation(event));

    const form = document.getElementById("contact-form");
    form.addEventListener('submit', (e) => {
        e.preventDefault();

        let data = {
            first_name: document.getElementById("first_name").value,
            last_name: document.getElementById("last_name").value,
            email: document.getElementById("email").value,
            phone_number: document.getElementById("phone_number").value,
            subject: document.getElementById("subject").value,
            message: document.getElementById("message").value,
        };

        let csrftoken = getCookie('csrftoken');

        fetch("/api/forms/contact/", {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken
            },
        })
        .then(res => res.json())
        .then(response => {
            if(response.id){
                const submitButton = document.getElementById("submitButton");
                const MessageModal = new Modal(submitButton, "#message-modal");
                MessageModal.open();
            }
        })
        .catch(response => { 
            console.log(response);
        });
    })
});
